import React from "react";
import styles from "../../styles/UserProfileInput.module.scss";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import classnames from "classnames";

export default function GenericInput(props) {
  const {
    title,
    inputValue,
    handleFieldChange,
    closeOnScroll,
    datePickerStyles,
    showMonthDropdown,
    showYearDropdown,
    errorState,
    errorMessage,
    maxDate,
    minDate,
    monthYearPicker=false,
    formatDate='M/dd/yyyy'
  } = props;

  function renderTitle() {
    if (title) {
      return <label className={styles.datePickerLabel}>{title}</label>;
    }
  }

  function dateClass(date){
    const newDate = `${date.getMonth()} ${date.getDate()}`;
    const selectedDate = `${inputValue.getMonth()} ${inputValue.getDate()}`;
    if (newDate === selectedDate){
      return datePickerStyles.selectedStyle
    }
    else if ( (minDate && date < minDate) || (maxDate && date > maxDate)){
      return datePickerStyles.dayDisableStyle;
    }
    else {
      return datePickerStyles.dayStyle;
    }
  }

  return (
    <div className={classnames(styles.datePickerWrapper, datePickerStyles.wrapper)}>
      {renderTitle()}
      <DatePicker
        closeOnScroll={closeOnScroll}
        selected={inputValue}
        onChange={handleFieldChange}
        calendarClassName={datePickerStyles.calendarDropdownStyle}
        dayClassName={(date) => dateClass(date)}
        className={
          errorState
            ? datePickerStyles.calendarError
            : datePickerStyles.generalClassName
        }
        showMonthDropdown={showMonthDropdown}
        showYearDropdown={showYearDropdown}        
        minDate={minDate ? minDate : null }
        maxDate={maxDate ? maxDate : null}
        dateFormat={formatDate}
        showMonthYearPicker={monthYearPicker}
      />
    
      <div className={styles.errorText}>{errorMessage}</div>
    </div>
  );
}
